interface ExternalTaskIdProps {
  value?: string | null;
  detail?: boolean;
}

export function ExternalTaskId({ value, detail = false }: ExternalTaskIdProps) {
  if (!value) {
    return null;
  }
  return detail ? (
    <div className="text-xs font-mono text-gray-500">
      External task ID: {value}
    </div>
  ) : (
    <span className="text-xs font-mono text-gray-500">External: {value}</span>
  );
}
